export default __webpack_public_path__ + "static/media/neel patel.43e23c75.jpg";